import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function Hero({
  desktopImg,
  mobileImg,
  eyebrow,
  title,
  titleAccent,
  subtitle,
  ctaLabel = "Richiedi una consulenza",
  ctaTo = "/contatti",
  secondaryLabel,
  secondaryTo,
  fullHeight = false,
  testId = "hero",
}) {
  const minH = fullHeight ? "min-h-[100vh]" : "min-h-[560px] md:min-h-[640px] h-[78vh]";
  return (
    <section className={`relative w-full ${minH} overflow-hidden bg-drosun-navy`} data-testid={testId}>
      <picture>
        <source media="(max-width: 768px)" srcSet={mobileImg} />
        <img
          src={desktopImg}
          alt=""
          aria-hidden="true"
          className="absolute inset-0 w-full h-full object-cover"
          fetchpriority="high"
          decoding="sync"
          loading="eager"
          width="1920"
          height="1080"
        />
      </picture>
      <div className="absolute inset-0 hero-overlay" aria-hidden />
      <div className="absolute inset-0 hero-vignette" aria-hidden />

      {/* Force text alignment to the LEFT — on large screens text stays at the far left of the page padding */}
      <div className="relative h-full max-w-[1500px] mx-auto px-5 lg:px-12 xl:px-16 2xl:px-24 flex items-center">
        <div className="max-w-[640px] py-24 text-white text-shadow-soft">
          {eyebrow && (
            <div className="inline-flex items-center gap-2 mb-5">
              <span className="inline-block w-10 h-[3px] bg-drosun-red" />
              <span className="text-sm font-semibold tracking-[0.18em] uppercase text-white/90">{eyebrow}</span>
            </div>
          )}
          <h1 className="font-display uppercase font-bold leading-[1.02] text-[40px] sm:text-[52px] lg:text-[64px] xl:text-[68px]">
            {title}
            {titleAccent && <span className="block text-drosun-red">{titleAccent}</span>}
          </h1>
          {subtitle && (
            <p className="mt-6 text-[18px] sm:text-[20px] leading-relaxed text-white/90 max-w-[600px]">
              {subtitle}
            </p>
          )}
          <div className="mt-8 flex flex-col sm:flex-row gap-4">
            {ctaLabel && (
              <Link
                to={ctaTo}
                className="inline-flex items-center justify-center gap-2 px-7 py-4 bg-drosun-red hover:bg-drosun-redHover text-white text-[14px] font-bold uppercase tracking-[0.12em] rounded-md transition-colors shadow-lg shadow-drosun-red/20"
                data-testid={`${testId}-cta-primary`}
              >
                {ctaLabel} <ArrowRight size={18} />
              </Link>
            )}
            {secondaryLabel && (
              <Link
                to={secondaryTo}
                className="inline-flex items-center justify-center gap-2 px-7 py-4 bg-transparent border border-white/40 hover:bg-white/10 text-white text-[14px] font-bold uppercase tracking-[0.12em] rounded-md transition-colors"
                data-testid={`${testId}-cta-secondary`}
              >
                {secondaryLabel}
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
